var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map"},[_c('iframe',{attrs:{"width":"100%","height":"100%","frameborder":"0","src":_vm.href}})])
}
var staticRenderFns = []

export { render, staticRenderFns }